<template>
  <div class="credit-cost-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Credit Cost' | trans }}</div>
    </div>
    <div class="d-flex justify-content-between" v-if="isLegacyUser === true">
      <span>{{ 'Total Cost' | trans }}</span>
      <div class="credit-cost-badge">
        <span class="font-weight-bold">{{ totalCost }}</span>
        <CoinSVG/>
      </div>
    </div>
    <div class="d-flex justify-content-between" v-if="isLegacyUser === false">
      <span>{{ 'Total Cost' | trans }}</span>
      <div class="credit-cost-badge">
          <span class="font-weight-bold d-flex align-items-center credit-cost-indicator">
              <span class="d-flex align-items-center gap-5">
                 8  <CoinSVG/>
              </span>
             /
              <span class="d-flex align-items-center  gap-5">
              10s <i class="far font-weight-bold fa-clock"></i>
              </span>
            </span>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <span>{{ 'Your Balance' | trans }}</span>
      <div class="credit-cost-badge">
        <span class="font-weight-bold">{{ userAvailableCredits }}</span>
        <CoinSVG/>
      </div>
    </div>
    <div class="credit-cost-btn" @click="getMoreCredits">
      <strong>{{ 'Get more Credits' | trans }}</strong
      ><i class="fa lh-inherit fa-chevron-right"></i>
    </div>
  </div>
</template>


<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import CreditManager from '../../manager/CreditManager';
import PaymentManager from '../../manager/PaymentManager';
import {userManager} from './../../../../../../../lib-sat/user/user-manager';
import user from './../../mixins/user.mixin';
import {EventBus} from '../../events/event.bus';
import {EVENT_CREDITS_UPDATE} from '../../events/credits.events';
import CoinSVG from './../../../form/icons/CoinSVG.vue';

export default {
  name: 'CreditCost',
  props: {},
  components: {CoinSVG},
  mixins: [store, currentJob, user],
  data() {
    return {};
  },
  mounted: function () {
    EventBus.$on(EVENT_CREDITS_UPDATE, () => {
      this.refreshUser();
    });
  },
  methods: {
    getMoreCredits() {
      if (this.isFreeUser) {
        PaymentManager.upgrade();
      } else {
        PaymentManager.buyCredits();
      }
    },
    async refreshUser() {
      await userManager.getFreshUser();
    },
  },
  computed: {
    totalCost() {
      return CreditManager.totalCost();
    },
  },
};
</script>
<style lang="scss">
.credit-cost-box {
  gap: 10px;
  display: flex;
  flex-direction: column;
}

.credit-cost-badge {
  display: flex;
  padding: 0px 5px;
  align-items: center;
  border-radius: 4px;
  background: #fa0;
  gap: 4px;
  color: #2e2e2e;
  font-size: 14px;
}

.credit-cost-indicator {
  gap: 3px;
}

.credit-cost-btn {
  cursor: pointer;
  display: flex;
  height: 38px;
  padding: 7px 20px;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #fa0;
  background: #fa0;
  color: #2e2e2e;

  &:hover {
    opacity: 0.8;
  }
}
</style>
